export default "__VITE_ASSET__B8jOBInh__"